export default __webpack_public_path__ + "static/media/swiss-flag.168bfcf6.svg";